import React from 'react'

import Lightbox from 'react-images'
import { css, StyleSheet } from 'aphrodite/no-important';
import theme from 'react-images/lib/theme';

import Arrow from 'react-images/lib/components/Arrow';
import Container from 'react-images/lib/components/Container';
import Footer from 'react-images/lib/components/Footer';
import Header from 'react-images/lib/components/Header';
import PaginatedThumbnails from 'react-images/lib/components/PaginatedThumbnails';
import Portal from 'react-images/lib/components/Portal';
import ScrollLock from './ScrollLock';

export default class FixedLightbox extends Lightbox {
  renderDialog(){
    const {
      backdropClosesModal,
      customControls,
      isOpen,
      onClose,
      showCloseButton,
      showThumbnails,
      width,
    } = this.props;

    if (!isOpen) return <span key="closed" />;

    let offsetThumbnails = 0;
    if (showThumbnails) {
      offsetThumbnails = theme.thumbnail.size + theme.container.gutter.vertical;
    }

    return (
      <Container
        key="open"
        onClick={!!backdropClosesModal && onClose}
        onTouchEnd={!!backdropClosesModal && onClose}
        style={{zIndex: 999999}}
      >
        <div className={css(classes.content)} style={{ marginBottom: offsetThumbnails, maxWidth: width }}>
          <Header
            customControls={customControls}
            onClose={onClose}
            showCloseButton={showCloseButton}
          />
          {this.renderImages()}
        </div>
        {this.renderThumbnails()}
        {this.renderArrowPrev()}
        {this.renderArrowNext()}
        <ScrollLock />
      </Container>
    );
  }
}

const classes = StyleSheet.create({
	content: {
		position: 'relative',
	},
	figure: {
		margin: 0, // remove browser default
	},
	image: {
		display: 'block', // removes browser default gutter
		height: 'auto',
		margin: '0 auto', // maintain center on very short screens OR very narrow image
		maxWidth: '100%',

		// disable user select
		WebkitTouchCallout: 'none',
		userSelect: 'none',
	},
});


/** WEBPACK FOOTER **
 ** ./src/profile/Lightbox.js
 **/